<template lang="pug">

  .lesson-test-question-answer(
    @click="$emit('selectAnswer')"
  )
    .lesson-test-question-answer__checkbox
      CheckboxBlock(
        :value="selectedAnswer"
        :disabled="true"
        :error="typeof isCorrect === 'boolean' ? !isCorrect : ''"
        :wrapperClass="[isMultipleAnswers && '-rect-' , classWrapperCheckbox]"
      )
    .lesson-test-question-answer__text
      | {{answer.text}}

</template>

<script>
import _ from 'lodash';
import CheckboxBlock from '@/components/Form/Checkbox';

export default {
  components: { CheckboxBlock },
  props: [
    'propAnswer',
    'isCorrectAnswer',
    'propSelectedAnswer',
    'isMultipleAnswers',
    'choosingArray'
  ],
  data: () => ({
    answer: {},
    selectedAnswer: false
  }),
  computed: {
    isCorrect() {
      return this.choosingArray.length > 0
        ? this.choosingArray.some(
            el => el === this.answer.id && this.answer.isCorrect
          )
        : '';
    },
    classWrapperCheckbox() {
      if (typeof this.isCorrect === 'boolean') {
        return this.getClassName();
      }
      return this.isCorrect;
    }
  },
  watch: {
    propAnswer() {
      this.setData();
    },
    propSelectedAnswer(val) {
      this.selectedAnswer = val;
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      this.answer = _.cloneDeep(this.propAnswer);
      this.selectedAnswer = this.propSelectedAnswer;
    },
    getClassName() {
      if (!this.isCorrect && this.answer.isCorrect) {
        return 'checkbox__error-success';
      }
      return this.isCorrect ? 'checkbox__success' : 'checkbox__error';
    }
  }
};
</script>
